import { useEffect } from "react";

import { AnimatePresence } from "framer-motion";

import { usePageTitle } from "@/atoms/page-title-atom";
import { LandingPageAnalyticsProvider } from "@features/landing-page-analytics";
import {
  Chart,
  FiltersBar,
  MinimizedTopBar,
  SearchBar,
  Table,
  TopBar,
} from "@features/landing-page-analytics/components";
import { useIntersectionObserver } from "@hooks/use-intersection-observer";

export const LandingPageAnalytics = () => {
  return (
    <LandingPageAnalyticsProvider>
      <LandingPageAnalyticsContent />
    </LandingPageAnalyticsProvider>
  );
};

export const LandingPageAnalyticsContent = () => {
  const [, setPageTitle] = usePageTitle();

  useEffect(() => {
    setPageTitle("Landing Page Analytics");
  }, [setPageTitle]);

  const [topLevelFiltersContainerElRef, isMinimizedTopBarVisible] =
    useIntersectionObserver();

  return (
    <div>
      <AnimatePresence>
        {isMinimizedTopBarVisible && <MinimizedTopBar />}
      </AnimatePresence>
      <div ref={topLevelFiltersContainerElRef}>
        <TopBar />
        <FiltersBar />
      </div>
      <Chart />
      <SearchBar />
      <Table />
    </div>
  );
};
